$(() => {
    if ($(window).width() > 789) {
        handleMouseState();
        removeMobile();
    } else {
        addMobile();
    }

    window.addEventListener("resize", function () {
        handleMouseState();

        if ($(window).width() > 789) {
            removeMobile();

        } else {
            addMobile();
        }
    })
});

const machinepresentationblock = document.getElementById('machinepresentationblock');

const el0 = document.getElementById('icon-0');
const hiddenEl0 = document.getElementById('information-box-0');
const el1 = document.getElementById('icon-1');
const hiddenEl1 = document.getElementById('information-box-1');
const el2 = document.getElementById('icon-2');
const hiddenEl2 = document.getElementById('information-box-2');
const el3 = document.getElementById('icon-3');
const hiddenEl3 = document.getElementById('information-box-3');
const el4 = document.getElementById('icon-4');
const hiddenEl4 = document.getElementById('information-box-4');

const hoverText = document.getElementById('hover-text');

const heightEl0 = hiddenEl0.offsetHeight;
const heightEl1 = hiddenEl1.offsetHeight;
const heightEl2 = hiddenEl2.offsetHeight;
const heightEl3 = hiddenEl3.offsetHeight;
const heightEl4 = hiddenEl4.offsetHeight;

function handleMouseState() {
    el0.addEventListener('mouseover', function handleMouseOver() {
        hiddenEl0.style.visibility = 'visible';
        hoverText.style.visibility = 'hidden';
        if (heightEl0 > 180) {
            machinepresentationblock.style.paddingBottom = (heightEl0 - 180)+"px";
        }
    });
    el0.addEventListener('mouseout', function handleMouseOut() {
        hiddenEl0.style.visibility = 'hidden';
        hoverText.style.visibility = 'visible';
        machinepresentationblock.style.paddingBottom = '0';
    });
    el1.addEventListener('mouseover', function handleMouseOver() {
        hiddenEl1.style.visibility = 'visible';
        hoverText.style.visibility = 'hidden';
        if (heightEl1 > 180) {
            machinepresentationblock.style.paddingBottom = (heightEl1 - 180)+"px";
        }
    });
    el1.addEventListener('mouseout', function handleMouseOut() {
        hiddenEl1.style.visibility = 'hidden';
        hoverText.style.visibility = 'visible';
        machinepresentationblock.style.paddingBottom = '0';
    });
    el2.addEventListener('mouseover', function handleMouseOver() {
        hiddenEl2.style.visibility = 'visible';
        hoverText.style.visibility = 'hidden';
        if (heightEl2 > 180) {
            machinepresentationblock.style.paddingBottom = (heightEl2 - 180)+"px";
        }
    });
    el2.addEventListener('mouseout', function handleMouseOut() {
        hiddenEl2.style.visibility = 'hidden';
        hoverText.style.visibility = 'visible';
        machinepresentationblock.style.paddingBottom = '0';
    });
    el3.addEventListener('mouseover', function handleMouseOver() {
        hiddenEl3.style.visibility = 'visible';
        hoverText.style.visibility = 'hidden';
        if (heightEl3 > 180) {
            machinepresentationblock.style.paddingBottom = (heightEl3 - 180)+"px";
        }
    });
    el3.addEventListener('mouseout', function handleMouseOut() {
        hiddenEl3.style.visibility = 'hidden';
        hoverText.style.visibility = 'visible';
        machinepresentationblock.style.paddingBottom = '0';
    });
    el4.addEventListener('mouseover', function handleMouseOver() {
        hiddenEl4.style.visibility = 'visible';
        hoverText.style.visibility = 'hidden';
        if (heightEl4 > 180) {
            machinepresentationblock.style.paddingBottom = (heightEl4 - 180)+"px";
        }
    });
    el4.addEventListener('mouseout', function handleMouseOut() {
        hiddenEl4.style.visibility = 'hidden';
        hoverText.style.visibility = 'visible';
        machinepresentationblock.style.paddingBottom = '0';
    });
}

function addMobile() {
    const element = document.getElementById("presentation");
    element.classList.add("isMobile");
}

function removeMobile() {
    const element = document.getElementById("presentation");
    element.classList.remove("isMobile");
}

